// extracted by mini-css-extract-plugin
module.exports = {"power-backup-H":"H_power-backup-H__cqAFa"};